import { appDePrevia, shellDoApp } from '../lib/app-bridge.js';
import { getSession, initialsOf } from '../lib/auth.js';
import { escapeHtml } from '../lib/html.js';

const ONBOARD = 'torre:app-onboarding';

const PAGINAS = [
  {
    titulo: 'Bem-vindo à Torre',
    texto: 'O aplicativo mostra o resultado da operação no celular. O painel do computador fica de fora.',
  },
  {
    titulo: 'Avisos de venda',
    texto: 'Pedido pago, cancelado e devolução chegam no aparelho. Vários avisos do mesmo tipo entram juntos, para não virar uma rajada.',
  },
  {
    titulo: 'Funciona com o app fechado',
    texto: 'A Apple no iPhone e o Google no Android entregam o aviso mesmo com a Torre fechada. Não precisa deixar o aplicativo aberto nem um processo rodando o tempo todo. O acesso pedido agora é o de notificação.',
  },
];

let onGo = null;
let onboardingAberto = false;
let modoAplicado = false;

export function modoApp() {
  return Boolean(shellDoApp());
}

function memoriaOnboarding() {
  return appDePrevia() ? sessionStorage : localStorage;
}

export function onboardingPendente() {
  if (!modoApp()) return false;
  try {
    return memoriaOnboarding().getItem(ONBOARD) !== '1';
  } catch {
    return false;
  }
}

function concluirOnboarding() {
  try {
    memoriaOnboarding().setItem(ONBOARD, '1');
  } catch {
    /* segue para o login mesmo se o aparelho bloquear o armazenamento */
  }
}

export function aplicarModoApp() {
  if (!modoApp()) return;
  document.documentElement.setAttribute('data-app', '1');
  garantirChrome();
  if (modoAplicado) return;
  modoAplicado = true;
  window.addEventListener('online', () => marcarRede(false));
  window.addEventListener('offline', () => marcarRede(true));
  window.addEventListener('torre:rede', (evento) => marcarRede(Boolean(evento.detail?.offline) || !navigator.onLine));
  if (!navigator.onLine) marcarRede(true);
}

function garantirChrome() {
  if (document.getElementById('app-tabbar')) return;
  const rede = document.createElement('div');
  rede.id = 'app-rede';
  rede.className = 'app-rede';
  rede.hidden = true;
  rede.innerHTML = `<span>Sem internet. Os números podem estar desatualizados.</span><button type="button" data-app-retry>Tentar de novo</button>`;
  const nav = document.createElement('nav');
  nav.id = 'app-tabbar';
  nav.className = 'app-tabbar';
  nav.innerHTML = `
    <button type="button" data-app-go="overview"><i>${icone('home')}</i><span>Início</span></button>
    <button type="button" data-app-go="vendas"><i>${icone('vendas')}</i><span>Vendas</span></button>
    <button type="button" data-app-go="notificacoes"><i>${icone('sino')}</i><span>Avisos</span></button>
    <button type="button" data-app-go="lojas"><i>${icone('loja')}</i><span>Lojas</span></button>
    <button type="button" data-app-go="perfil"><i>${icone('perfil')}</i><span>Perfil</span></button>
  `;
  document.body.append(rede, nav);
  document.addEventListener('click', (evento) => {
    if (!modoApp()) return;
    const retry = evento.target.closest('[data-app-retry]');
    if (retry) {
      evento.preventDefault();
      window.location.reload();
      return;
    }
    const alvo = evento.target.closest('[data-app-go]');
    if (!alvo) return;
    evento.preventDefault();
    onGo?.(alvo.dataset.appGo);
  });
}

export function bindAppMode(ir) {
  onGo = ir;
}

export function marcarAbaApp(id) {
  document.querySelectorAll('#app-tabbar [data-app-go]').forEach((botao) => {
    botao.classList.toggle('on', botao.dataset.appGo === id);
  });
}

function marcarRede(offline) {
  const barra = document.getElementById('app-rede');
  if (barra) barra.hidden = !offline;
  document.documentElement.toggleAttribute('data-offline', offline);
}

export function mostrarOnboarding(aoTerminar) {
  if (onboardingAberto) return;
  onboardingAberto = true;
  document.documentElement.setAttribute('data-screen', 'onboarding');
  let pagina = 0;
  const root = document.createElement('section');
  root.className = 'app-onboarding';
  root.innerHTML = `
    <button type="button" class="app-onboarding-skip" data-onboard="pular">Pular</button>
    <div class="app-onboarding-stage" data-onboard="stage"></div>
    <div class="app-onboarding-foot">
      <div class="app-onboarding-dots" data-onboard="dots"></div>
      <button type="button" class="app-onboarding-next" data-onboard="next">Próximo</button>
    </div>
  `;
  document.body.append(root);

  const pintar = () => {
    const item = PAGINAS[pagina];
    const ultimo = pagina === PAGINAS.length - 1;
    root.querySelector('[data-onboard="stage"]').innerHTML = `
      <div class="app-onboarding-mark">TORRE DE <span>CONTROLE</span></div>
      <h2>${item.titulo}</h2>
      <p>${item.texto}</p>
      ${ultimo ? `<button type="button" class="app-onboarding-permitir" data-onboard="permitir">Permitir notificações</button><p class="app-onboarding-nota" data-onboard="nota"></p>` : ''}
    `;
    root.querySelector('[data-onboard="dots"]').innerHTML = PAGINAS.map((_, indice) =>
      `<i class="${indice === pagina ? 'on' : ''}"></i>`
    ).join('');
    root.querySelector('[data-onboard="next"]').textContent = ultimo ? 'Começar' : 'Próximo';
  };

  root.addEventListener('click', async (evento) => {
    const acao = evento.target.closest('[data-onboard]')?.dataset.onboard;
    if (!acao || acao === 'stage' || acao === 'dots' || acao === 'nota') return;
    if (acao === 'permitir') {
      const nota = root.querySelector('[data-onboard="nota"]');
      const resultado = await window.torreApp?.pedirNotificacao?.();
      if (nota) {
        nota.textContent = resultado === 'denied'
          ? 'As notificações ficaram bloqueadas. Você pode liberar depois nos ajustes do celular.'
          : 'Acesso pedido. As vendas passam a chegar neste aparelho.';
      }
      return;
    }
    if (acao === 'next' && pagina === PAGINAS.length - 1) {
      await window.torreApp?.pedirNotificacao?.();
      concluirOnboarding();
      root.remove();
      onboardingAberto = false;
      aoTerminar?.();
      return;
    }
    if (acao === 'pular') {
      concluirOnboarding();
      root.remove();
      onboardingAberto = false;
      aoTerminar?.();
      return;
    }
    if (acao === 'next') {
      pagina += 1;
      pintar();
    }
  });
  pintar();
}

export function renderAppHome(dados) {
  const sessao = getSession();
  const nome = escapeHtml(sessao?.name || 'Torre');
  const aviso = dados.offline
    ? `<div class="app-aviso">Não foi possível atualizar agora. Os números abaixo podem estar vazios até a conexão voltar.</div>`
    : '';
  return `
    <header class="app-head">
      <div class="app-logo">TORRE DE <span>CONTROLE</span></div>
      <button type="button" class="app-bell" data-app-go="notificacoes" aria-label="Avisos">${icone('sino')}</button>
    </header>
    ${aviso}
    <section class="app-saldo">
      <div class="app-saldo-top">
        <span>${escapeHtml(dados.rotulo || 'Lucro')} ${escapeHtml(dados.periodo || '')}</span>
        <button type="button" class="app-eye" data-action="toggle-eye" aria-label="Mostrar ou ocultar valores">${icone('olho')}</button>
      </div>
      <strong class="${dados.positivo ? 'pos' : 'neg'}">${dados.lucro}</strong>
      <button type="button" class="app-link" data-app-go="vendas">Ver vendas</button>
      <div class="app-saldo-sub">
        <span>${escapeHtml(dados.detalhe || 'Faturamento')} <b>${dados.receita}</b></span>
        <span>Gasto <b>${dados.gasto}</b></span>
      </div>
    </section>
    <h3 class="app-sec">Ações rápidas</h3>
    <div class="app-acoes">
      <button type="button" data-app-go="vendas"><i>${icone('vendas')}</i><span>Vendas</span></button>
      <button type="button" data-app-go="notificacoes"><i>${icone('sino')}</i><span>Avisos</span></button>
      <button type="button" data-app-go="lojas"><i>${icone('loja')}</i><span>Lojas</span></button>
      <button type="button" data-app-go="tracker"><i>${icone('alvo')}</i><span>Rastreio</span></button>
    </div>
    <h3 class="app-sec">Atalhos</h3>
    <div class="app-atalhos">
      <button type="button" data-app-go="campanhas"><i>${icone('grafico')}</i><span>Campanhas</span><em>›</em></button>
      <button type="button" data-app-go="relatorios"><i>${icone('doc')}</i><span>Relatórios</span><em>›</em></button>
      <button type="button" data-app-go="produtos"><i>${icone('caixa')}</i><span>Produtos</span><em>›</em></button>
      <button type="button" data-app-go="perfil"><i>${icone('perfil')}</i><span>${nome}</span><em>›</em></button>
    </div>
  `;
}

export function renderAppPerfil() {
  const sessao = getSession();
  const nome = escapeHtml(sessao?.name || 'Operador');
  const email = escapeHtml(sessao?.email || '');
  const letras = escapeHtml(initialsOf(sessao || {}));
  return `
    <header class="app-head">
      <div class="app-logo">Perfil</div>
    </header>
    <section class="app-perfil">
      <div class="app-perfil-av">${letras}</div>
      <strong>${nome}</strong>
      <span>${email}</span>
    </section>
    <div class="app-atalhos">
      <button type="button" data-app-go="notificacoes"><i>${icone('sino')}</i><span>Notificações</span><em>›</em></button>
      <button type="button" data-logout><i>${icone('sair')}</i><span>Sair</span><em>›</em></button>
    </div>
  `;
}

export function cabecalhoApp(titulo) {
  return `
    <header class="app-head app-head-sec">
      <button type="button" class="app-back" data-app-go="overview" aria-label="Início">${icone('voltar')}</button>
      <div class="app-logo">${escapeHtml(titulo || '')}</div>
      <button type="button" class="app-bell" data-app-go="notificacoes" aria-label="Avisos">${icone('sino')}</button>
    </header>
  `;
}

function icone(nome) {
  const traço = 'fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
  const mapa = {
    home: `<svg viewBox="0 0 24 24" ${traço}><path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1z"/></svg>`,
    vendas: `<svg viewBox="0 0 24 24" ${traço}><path d="M6 7h12l-1 13H7z"/><path d="M9 7V6a3 3 0 0 1 6 0v1"/></svg>`,
    sino: `<svg viewBox="0 0 24 24" ${traço}><path d="M6 16V11a6 6 0 1 1 12 0v5l1.5 2h-15z"/><path d="M10 19a2 2 0 0 0 4 0"/></svg>`,
    loja: `<svg viewBox="0 0 24 24" ${traço}><path d="M4 10h16v9H4z"/><path d="M3 10l2-5h14l2 5"/><path d="M10 19v-5h4v5"/></svg>`,
    perfil: `<svg viewBox="0 0 24 24" ${traço}><circle cx="12" cy="8" r="3.2"/><path d="M5 19c1.4-3 3.8-4.5 7-4.5S17.6 16 19 19"/></svg>`,
    alvo: `<svg viewBox="0 0 24 24" ${traço}><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg>`,
    grafico: `<svg viewBox="0 0 24 24" ${traço}><path d="M4 19V5M4 19h16"/><path d="M8 15l4-5 3 3 5-7"/></svg>`,
    doc: `<svg viewBox="0 0 24 24" ${traço}><path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5M9 13h6M9 17h6"/></svg>`,
    caixa: `<svg viewBox="0 0 24 24" ${traço}><path d="M3 8l9-4 9 4-9 4z"/><path d="M3 8v8l9 4 9-4V8"/><path d="M12 12v8"/></svg>`,
    olho: `<svg viewBox="0 0 24 24" ${traço}><path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12z"/><circle cx="12" cy="12" r="2.5"/></svg>`,
    voltar: `<svg viewBox="0 0 24 24" ${traço}><path d="M15 6l-6 6 6 6"/></svg>`,
    sair: `<svg viewBox="0 0 24 24" ${traço}><path d="M10 7V5h9v14h-9v-2"/><path d="M4 12h10M10 8l-4 4 4 4"/></svg>`,
  };
  return mapa[nome] || '';
}
